// Alle product sliders
let productSwiper = new Swiper(".productSwiper", {
    slidesPerView: "auto",
    spaceBetween: 10,
    centerInsufficientSlides: false,
    scrollbar: {
        el: ".swiper-scrollbar",
        // snapOnRelease: true,
        dragSize: 300,
        draggable: true,
        hide: false,
    },
    breakpoints: {
        320: {
            scrollbar: {
                dragSize: 60,
            },
        },
        768: {
            scrollbar: {
                dragSize: 300,
            },
        },
    }
});

// swiper for usp footer bar
let uspSwiper = new Swiper(".uspSwiper", {
    slidesPerView: 1,
    autoHeight: true,
    direction: "vertical",
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    freeMode: {
        enabled: true,
        minimumVelocity: 0.5,
        momentumRatio: 0.25
    },
});

let bannerSwiper = new Swiper(".bannerSwiper", {
		slidesPerView: 2,
    autoHeight: true,
  	spaceBetween: 10,
    autoplay: {
        delay: 2500,
        disableOnInteraction: true,
    },
    freeMode: {
        enabled: true,
        minimumVelocity: 0.5,
        momentumRatio: 0.25
    },
});

let homeSwiper = new Swiper(".homeSwiper", {
    slidesPerView: 1,
    autoHeight: true,
    direction: "horizontal",
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    breakpoints: {
        655: {
            slidesPerView: 2, 
        }
    },
    freeMode: {
        enabled: true,
        minimumVelocity: 0.5,
        momentumRatio: 0.25
    },
});

// swiper
let promoSwiper = new Swiper(".promoSwiper", {
    slidesPerView: 1,
    autoHeight: true,
    direction: "horizontal",
    autoplay: {
        delay: 1500,
        disableOnInteraction: true,
    },
    freeMode: {
        enabled: true,
        minimumVelocity: 0.5,
        momentumRatio: 0.25
    },
});



// blog slider
let blogSwiper = new Swiper(".blogSwiper", {
    slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 10,
   navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
});

// product image thumbnail slider
let thumbs = new Swiper('.productImageThumbnailSlider', {
    slidesPerView: "auto",
    spaceBetween: 10,
    freeMode: {
        enabled: true,
        sticky: true,
        minimumVelocity: 0.5,
        momentumRatio: 0.25
    },
});

let productImageSlider = new Swiper('.productImages', {
    loop: true,
    spaceBetween: 16,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    thumbs: {
        swiper: thumbs,
    },
});